import React, { useEffect, useState, useContext } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import { LoadingContext } from "../../App";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";
import ChartBar from "../../componets/ChartBar";
import ChartArea from "../../componets/ChartArea";

const Analize = props => {
	const { addPageSpinner, removePageSpinner, pageSpinner } =
		useContext(LoadingContext);
	let [searchParams] = useSearchParams();
	const symbol = searchParams.get("symbol");

	let index = 0;
	const [coinData, setCoinData] = useState(null);
	const [analize, setDepth] = useState(null);
	const [search, setSearch] = useState("");

	useEffect(() => {
		getCoinData(symbol);
	}, [symbol]);

	const getCoinData = symbol => {
		if (!symbol) {
			return false;
		}
		const spinnerId = Math.random();
		addPageSpinner(spinnerId);
		setDepth(null);
		ApiService.getCoin(symbol)
			.then(response => {
				if (response && response.data) {
					setCoinData(response.data);
					let data = { ...response.data };
					let _data = {
						name: data.name,
						baseSymbol: data.symbol,
						totalSupply: data.circulatingSupply,
						price: Object.values(data.quote)[0]?.price,
						capitalization: Object.values(data.quote)[0]?.marketCap,
						limit: 5000,
						pairSymbols: ["USDT", "USDC", "DAI", "TUSD"],
					};
					getDepth(_data);
				} else {
					setCoinData(null);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				removePageSpinner(spinnerId);
			});
	};

	const getDepth = search => {
		const spinnerId = Math.random();
		addPageSpinner(spinnerId);
		ApiService.getDepth(search)
			.then(response => {
				if (response && response.data) {
					setDepth(response.data);
				} else {
					setDepth(null);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				removePageSpinner(spinnerId);
			});
	};

	const onSubmit = event => {
		event && event.preventDefault();
		getCoinData(search);
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/coins">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0 ">Analize</h4>
					</div>
					{/* <Form onSubmit={onSubmit}>
                        <Form.Group controlId="search" className="d-flex gap-2 align-items-center">
                            <Form.Control
                                type="search"
                                value={search}
                                size="sm"
                                placeholder="Search..."
                                onChange={(event) => setSearch(event.target.value ? event.target.value.toUpperCase() : "")}
                            />
                            <Button
                                size="sm"
                                variant="primary"
                                type="submit"
                                disabled={pageSpinner.length}
                            >
                                Search
                            </Button>
                        </Form.Group>
                    </Form> */}
				</div>
			</Header>
			<div mt={4} className="d-flex justify-content-between w-100 mb-4">
				<Form onSubmit={onSubmit} style={{ width: "30rem" }}>
					<Form.Group
						controlId="search"
						className="d-flex gap-2 align-items-center">
						<Form.Control
							type="search"
							value={search}
							size="sm"
							placeholder="Address..."
							onChange={event =>
								setSearch(
									event.target.value ? event.target.value.toUpperCase() : "",
								)
							}
						/>
						<Button
							disabled={!search.trim().length}
							size="sm"
							variant="primary"
							type="submit">
							Search
						</Button>
					</Form.Group>
				</Form>
			</div>
			<Row>
				<Col cm={12}>
					<Row>
						<Col sm={6}>
							{coinData ? (
								<div>
									<div className="d-flex align-items-center mb-2">
										<img
											className="me-2"
											src={coinData.logo}
											width={40}
											alt="logo"
										/>
										<h2 className="text-left">
											<b>{coinData.symbol}</b> ({coinData.name})
										</h2>
									</div>
									<h6 className="text-left">
										<b>Total Suplay</b>- {coinData.totalSupply}
									</h6>
									<h6 className="text-left">
										<b>Circulating Suplay</b> - {coinData.circulatingSupply}
									</h6>
									<h6 className="text-left">
										<b>Capitalization</b> -{" "}
										{coinData.quote && Object.values(coinData.quote).length
											? `${Object.values(coinData.quote)[0].marketCap} (${
													Object.keys(coinData.quote)[0]
											  }) `
											: 0}
									</h6>
								</div>
							) : null}

							{!!analize && <ChartArea data={analize} />}
						</Col>
						<Col sm={6}>
							{coinData?.platform ? (
								<div>
									<h2 className="text-left">
										<b>Platform ({coinData.platform.name})</b>
									</h2>
									<h6 className="text-left">
										<b>Token address</b>- {coinData.platform.tokenAddress}
									</h6>
								</div>
							) : null}
							{coinData?.contracts ? (
								<div>
									<h2 className="text-left">
										<b>Contracts</b>
									</h2>
									{coinData.contracts.map((item, index) => {
										return (
											<h6 key={index} className="text-left">
												<b>{item.chainName}</b> - {item.contractAddress}
											</h6>
										);
									})}
								</div>
							) : null}
						</Col>
					</Row>
					<hr />
					<Row>
						{analize &&
							analize.analizeData &&
							Object.entries(analize.analizeData).map(([key, value], index) => {
								return (
									<Col key={index} lg={6} md={12} sm={12}>
										<h5 className="fw-bold">{key}</h5>
										<ChartBar data={value} />
									</Col>
								);
							})}
					</Row>
				</Col>
			</Row>
		</div>
	);
};

export default Analize;
